import { useState } from 'react';
import { Trans } from 'react-i18next';
import { Button, Form, Typography } from 'antd';
import cn from 'classnames';

import { ModalComponent } from 'componets/common';
import { CheckBoxField, FormItem, SubmitButton } from 'componets/form';

import { Rules } from 'utils/constants';
import { language } from 'utils';

import { FieldData } from 'models';

import { useAppDispatch, useAppSelector, useTranslate } from 'hooks';

import { acceptAgreement } from 'features/user/actions';

import styles from './index.module.scss';
import { selectIsAdmin } from '../../../selectors';

export const AgreeWithTerms = () => {
	const isAdmin = useAppSelector(selectIsAdmin);

	const { consentText, skipForText } = useTranslate(['consentText', 'skipForText']);

	const [isOpen, setIsOpen] = useState(true);
	const [form] = Form.useForm();
	const [fields, setFields] = useState<FieldData[]>([]);

	const dispatch = useAppDispatch();
	const onFinish = () => {
		dispatch(acceptAgreement({ agreeWithPolicy: true, agreeWithTerms: true })).then(() => {
			setIsOpen(false);
		});
	};

	const link =
		language === 'lt'
			? 'https://crowdpear.com/wp-content/uploads/2023/08/Sutelktinio_finansavimo_platformos_crowdpear_naudojimosi_sutartis.pdf'
			: 'https://crowdpear.com/wp-content/uploads/2023/08/Usage_Agreement_Of_The_Crowdfunding_Platform_Crowdpear.pdf';

	return (
		<ModalComponent
			title={
				<Trans
					i18nKey="agreeWithTermsTitleText"
					components={{
						l: <a href={link} target="_blank" rel="noreferrer" className={styles.link} />,
					}}
				/>
			}
			isOpen={isOpen}
			onClose={() => {
				setIsOpen(false);
			}}
			className={styles.root}
			width="450px"
		>
			<Form form={form} onFinish={onFinish} onFieldsChange={setFields} fields={fields}>
				<div className="modal-content">
					<Typography.Text className={styles.text}>
						<Trans
							i18nKey="agreeWithTermsInfoText"
							components={{
								l: <a href={link} target="_blank" rel="noreferrer" className={styles.link} />,
							}}
						/>
					</Typography.Text>

					<FormItem
						name="agree"
						rules={[Rules.REQUIRED_CHECKBOX]}
						className={`${styles.agree} checkbox`}
					>
						<CheckBoxField
							text={
								<Trans
									i18nKey="agreeWithTermsCheckboxText"
									components={{
										l: (
											<a href={link} target="_blank" rel="noreferrer" className="modal-agreeLink" />
										),
									}}
								/>
							}
						/>
					</FormItem>

					<div className="modal-footer">
						<SubmitButton
							text={consentText}
							classNameWrapper={styles.submitWrapper}
							className={cn(styles.button, { 'ant-btn-grey': isAdmin })}
						/>
						<Button onClick={() => setIsOpen(false)} className={styles.button}>
							{skipForText}
						</Button>
					</div>
				</div>
			</Form>
		</ModalComponent>
	);
};
